

























































import Vue from "vue";
import { debounce } from "lodash";
import { User } from "@/common/models/User";
import { userService as UAUserService } from "@/user-administration/services/UAUserService";
import { userService } from "@/common/services/UserService";
import { accessService } from "@/user-administration/services/UAAccessService";
import { Access } from "@/common/models/Access";
import { AccessLevel } from "@/common/enums/AccessLevel";

export default Vue.extend({
  name: "UAAddUser",
  props: {
    storeId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      errors: [] as string[],
      loadingUser: false,
      user: undefined as User | undefined,
      foundUsers: [] as User[],
      search: null,
      selectedAccessLevel: AccessLevel.STAFF,
      userService,
      savingUser: false,
      AccessLevel,
    };
  },
  computed: {
    debouncedSearch(): (email: string) => void {
      return debounce((email: string) => {
        UAUserService.getUsers(email).then((result) => {
          this.foundUsers = result;
          if (!result || result.length <= 0) {
            this.errors = [this.$t("modules.user-administration.add-user.search-error").toString()];
          }
          this.loadingUser = false;
        });
      }, 500);
    },
  },
  watch: {
    search(val: string): void {
      this.errors = [];
      if (val.length <= 5) {
        this.loadingUser = false;
        return;
      }
      this.loadingUser = true;
      this.debouncedSearch(val);
    },
  },
  methods: {
    async saveUser(user: User, accessLevel: string): Promise<void> {
      this.savingUser = true;
      await accessService.createAccess(new Access(user.userId, this.storeId, "STORE", accessLevel));
      this.savingUser = false;
      this.$emit("saved");
    },
    onClose(): void {
      this.loadingUser = false;
      this.foundUsers = [];
      this.user = undefined;
      this.$emit("close");
    },
  },
});
